import React, {Component} from "react";
import PropTypes from "prop-types";
import DatePicker from "material-ui/DatePicker";
import {FieldTitle} from "admin-on-rest";
import TimePicker from "material-ui/TimePicker";
import calendarIcon from "../images/calendar.svg";

let DateTimeFormat;
DateTimeFormat = global.Intl.DateTimeFormat;

export const datify = input => {
  if (!input) {
    return null;
  }

  const date = input instanceof Date ? input : new Date(input);
  if (isNaN(date)) {
    throw new Error(`Invalid date: ${input}`);
  }

  return date;
};

class DateTimeInput extends Component {
  onChange = (_, date) => {
    if (this.props.input.value) {
      let tempDate = new Date(this.props.input.value);
      date.setHours(tempDate.getHours());
      date.setMinutes(tempDate.getMinutes());
      date.setSeconds(tempDate.getSeconds());
    }

    this.props.input.onChange(date);
    this.props.input.onBlur();
    this.refs[`${this.props.source}.timePicker`].openDialog();
  };

  onChangeTime = (_, time) => {
    this.props.input.onChange(time);
    this.props.input.onBlur();
  };

  clearDate = () => {
    this.props.input.onChange(null);
    this.props.input.onBlur();
  };

  onBlur = () => {};

  onDismiss = () => this.props.input.onBlur();

  render() {
    const {
      input,
      isRequired,
      label,
      meta,
      options,
      source,
      resource,
      locale,
      hideCalendarDate,
      labelTime,
      timeFormat,
      optionsTime,
      dateStyle,
      timeStyle,
      textFieldStyle,
      wrapperStyle,
      customLabelStyle,
      leftLabel,
      afterLabelText,
      underlineShow,
      afterInputText,
      afterInputTextStyle,
      customHintStyle,
      customInputStyle,
      showIcon
    } = this.props;
    if (typeof meta === "undefined") {
      throw new Error(
        "The DateTimeInput component wasn't called within a redux-form <Field>. Did you decorate it and forget to add the addField prop to your component? See https://marmelab.com/admin-on-rest/Inputs.html#writing-your-own-input-component for details."
      );
    }
    const {touched, error} = meta;

    return (
      <div style={wrapperStyle}>
        <div style={customLabelStyle}>
          {leftLabel ? (
            <FieldTitle
              label={leftLabel}
              source={source}
              resource={resource}
              isRequired={isRequired}
            />
          ) : null}

          {afterLabelText ? (
            <span style={afterInputTextStyle}>{afterLabelText}</span>
          ) : null}
        </div>

        <DatePicker
          {...input}
          inputStyle={customInputStyle}
          errorText={touched && error}
          hintText={
            <FieldTitle
              label={label}
              source={source}
              resource={resource}
              isRequired={isRequired}
            />
          }
          hintStyle={customHintStyle}
          DateTimeFormat={Intl.DateTimeFormat}
          hideCalendarDate={hideCalendarDate}
          locale={locale}
          underlineShow={underlineShow}
          formatDate={
            new DateTimeFormat("sv", {
              year: "numeric",
              month: "numeric",
              day: "numeric"
            }).format
          }
          container="dialog"
          autoOk
          value={datify(input.value)}
          onChange={this.onChange}
          onBlur={this.onBlur}
          onDismiss={this.onDismiss}
          style={dateStyle}
          textFieldStyle={textFieldStyle}
          ref={`${this.props.source}.datePicker`}
          {...options}
        />

        {afterInputText ? (
          <span style={afterInputTextStyle}>{afterInputText}</span>
        ) : null}

        <TimePicker
          {...input}
          inputStyle={customInputStyle}
          errorText={touched && error}
          hintText={
            <FieldTitle
              label={labelTime}
              source={source}
              resource={resource}
              isRequired={isRequired}
            />
          }
          hintStyle={customHintStyle}
          underlineShow={underlineShow}
          format={timeFormat ? timeFormat : "24hr"}
          autoOk
          textFieldStyle={textFieldStyle}
          value={datify(input.value)}
          onChange={this.onChangeTime}
          onBlur={this.onBlur}
          onDismiss={this.onDismiss}
          style={timeStyle}
          ref={`${this.props.source}.timePicker`}
          {...optionsTime}
        />

        {showIcon ? (
          <div style={{paddingTop: "1.5%", marginRight: "3%"}}>
            <img src={calendarIcon} alt="calendarIcon" />
          </div>
        ) : null}
      </div>
    );
  }
}

DateTimeInput.propTypes = {
  addField: PropTypes.bool.isRequired,
  elStyle: PropTypes.object,
  input: PropTypes.object,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  meta: PropTypes.object,
  options: PropTypes.object,
  resource: PropTypes.string,
  source: PropTypes.string,
  labelTime: PropTypes.string
};

DateTimeInput.defaultProps = {
  addField: true,
  options: {}
};

export default DateTimeInput;



// WEBPACK FOOTER //
// ./src/components/DateTimeInput.js